/**
 * Safely gets window.location.href during client-side navigation
 * Returns an empty string if window.location is not available or href is invalid
 */
export const getSafeLocationHref = (): string => {
  try {
    if (!window?.location?.href) {
      return ''
    }
    return window.location.href
  } catch (error) {
    // During client-side navigation in Next.js, window.location might throw errors
    try {
      // Fallback to pathname + search + hash if available
      if (window?.location) {
        return (
          (window.location.origin || '') +
          (window.location.pathname || '') +
          (window.location.search || '') +
          (window.location.hash || '')
        )
      }
    } catch {
      // If we can't access location at all, return empty string
      return ''
    }
    return ''
  }
}

/**
 * Safely constructs a URL from window.location.href or a provided URL string
 * Returns an empty string if URL construction fails
 */
export const getSafeUrl = (url?: string): string => {
  try {
    const href = url ?? getSafeLocationHref()
    if (!href) {
      return ''
    }
    return new URL(href).href
  } catch (error) {
    // If URL construction fails, return empty string
    return ''
  }
}
